import { SplashScreen } from "@capacitor/splash-screen"
import { listenPushTaps, readTelegramTap } from "@/app/notification-taps"
import { initLiveUpdate } from "@/app/updates/ota"
import { migrateLegacyPendingPurchases } from "@/features/purchase"
import { captureError } from "@/shared/lib/diagnostics"
import {
	detectPlatform,
	detectStore,
	initKeyboardTracking,
	type Platform,
	type StoreId,
} from "@/shared/lib/platform"
import {
	bootstrapTelegramStore,
	isDesktopPlatform,
} from "@/shared/lib/telegram"

export interface Environment {
	platform: Platform
	store: StoreId | null
	isDesktopBlocked: boolean
}

/** Cheap, network-free work that must land before the first render. */
export function prepare(): Environment {
	const platform = detectPlatform()
	const store = detectStore()

	// Confirms the OTA bundle before the auto-rollback timer fires.
	initLiveUpdate()
	// Before auth: a clearSession would remove the legacy key.
	if (store === "rustore") migrateLegacyPendingPurchases()
	if (platform === "android" || platform === "ios") {
		void SplashScreen.hide().catch((error) => {
			captureError(error, { scope: "boot.splash" })
		})
	}
	// Feeds platform-conditional CSS before the first paint.
	document.documentElement.dataset.platform = platform
	initKeyboardTracking(platform)
	listenPushTaps()

	const isDesktopBlocked = prepareTelegram(platform)
	return { platform, store, isDesktopBlocked }
}

function prepareTelegram(platform: Platform): boolean {
	if (platform !== "telegram") return false

	bootstrapTelegramStore()
	// Reads the tgWebApp hash, so it must run before the strip below.
	readTelegramTap()
	stripLaunchParamsFromUrl()
	return isDesktopPlatform()
}

function stripLaunchParamsFromUrl(): void {
	if (!window.location.hash.includes("tgWebApp")) return

	window.history.replaceState(
		window.history.state,
		"",
		window.location.pathname + window.location.search,
	)
}
